import { type FlipIntent } from 'wdc-cube'
import {
    TcmPresenterForFilterCatalogForm,
    TcmPresenterForFilterCatalogShare,
    type FilterCatalogDialogContext
} from '../the-consumer-market/tcm_presenter_filter_pane/tcm_filter_catalog_presenter'
import { AdFilterCatalogFormKeys, AdFilterCatalogShareKeys, AnaliseDesempenhoKeys } from './ad_keys'

export class AdFilterCatalogFormPresenter extends TcmPresenterForFilterCatalogForm {
    protected override resolveContext(intent: FlipIntent): FilterCatalogDialogContext {
        const keys = new AdFilterCatalogFormKeys(this.app, intent)
        return {
            mode: keys.mode,
            sourceId: keys.sourceId,
            catalog: keys.adPresenter.filterPane.catalog,
            dialogSlot: (scope) => keys.dialogSlot(scope)
        }
    }

    protected override async flipBack() {
        await new AnaliseDesempenhoKeys(this.app).flip()
    }
}

export class AdFilterCatalogSharePresenter extends TcmPresenterForFilterCatalogShare {
    protected override resolveContext(intent: FlipIntent): FilterCatalogDialogContext {
        const keys = new AdFilterCatalogShareKeys(this.app, intent)
        return {
            mode: 'create',
            sourceId: keys.sourceId,
            catalog: keys.adPresenter.filterPane.catalog,
            dialogSlot: (scope) => keys.dialogSlot(scope)
        }
    }

    protected override async flipBack() {
        await new AnaliseDesempenhoKeys(this.app).flip()
    }
}
